import React, {memo, useCallback, useMemo, useRef, useState} from "react"
import {useSelector} from "react-redux"
import arrowIcon from "../../../../assets/images/icons/footer/arrow-top.png"
import {SelectButton} from "./SelectButton"
import {onClickHandler} from "../../../../utils/onclick"
import "./index.scss"

type Raw = {
    selected: boolean
    id: string
}
type Props<T = Raw> = {
    changeDevice: (id: string) => void
    selectedDevice: T
}

export const SelectDevice = memo(function SelectDevice({changeDevice, selectedDevice}: Props) {
    const sliderRef = useRef<any>(null)
    const screenWidth = window.innerWidth
    const [sliderRefValue, setSliderRefValue] = useState(0)
    const controls = useSelector(state => state.control.controlList)
     const controlList = controls.filter(control => control?.temperature_settings)
    const onClickNextDevice = useCallback(() => {
        setSliderRefValue((sliderRef.current.scrollLeft += 300))
        return (sliderRef.current.scrollLeft += 300)
    }, [])
    const onClickPrevDevice = useCallback(() => {
        setSliderRefValue((sliderRef.current.scrollLeft -= 300))
        return (sliderRef.current.scrollLeft -= 300)
    }, [])
    const Devices = useMemo(() => controlList, [controlList])
    const screenQuery = useCallback(
        (action: string, onClick: () => void) => {
            return (
                <div
                    className={`device-slider-icon-container ${action} ${
                        screenWidth >= 1024
                            ? Devices.length < 7
                                ? "_arrow-hide"
                                : ""
                            : screenWidth <= 600
                            ? Devices.length < 4
                                ? "_arrow-hide"
                                : ""
                            : ""
                    }`}
                    onClick={onClick}
                >
                    <img src={arrowIcon} alt="" />
                </div>
            )
        },
        [screenWidth, Devices]
    )
    return (
        <div className="select-device-container">
            {screenQuery("_prev", onClickPrevDevice)}
            <span ref={sliderRef}>
                {Devices.map(device => (
                    <SelectButton
                        key={device.id}
                        id={device.id}
                        name={device.name}
                        is_selected={(selectedDevice.id === device.id && selectedDevice.selected) || false}
                        {...onClickHandler(() => changeDevice(device.id))}
                    />
                ))}
            </span>
            {screenQuery("_next", onClickNextDevice)}
        </div>
    )
})
